@if (showAudioPlayer) {
<audio #audioPlayer crossorigin="anonymous" [src]="_url" controls style="display: none;"></audio>
<audio #audioPlayer2 crossorigin="anonymous" [src]="_url" controls style="display: none;"></audio>

<div class="audio-block-wrapper --minimized" *ngIf="isMiniFloater">
  <div class="flex-col-sm-12 --low-spacing">
    <div class="audio-block-header">
      <h4>{{formatDate(getCurrentTime())}}</h4>
      <div class="flex-col-sm-8">
        <!-- <div class="audio-seekbar">
                            <div class="audio-progress-bar">
                              <div class="audio-knob"></div>
                            </div>
                          </div> -->
        <div class="audio-seekbar" (mousemove)="showHoverTime($event)" (mouseleave)="hideHoverTime()">
          <input type="range" #seekBar [(ngModel)]="seekBarValue" (input)="seekAudio($event)" class="audio-progress-bar"
            min="0" max="100" value="0" id="audioSeekbar1" />
        </div>
        <ng-container *ngIf="isAudioLoaded">
          <div *ngIf="hoverTimeVisible" class="hover-time-tooltip" [style.top.px]="tooltipPositionY"
            [style.left.px]="tooltipPositionX">
            {{ hoverTime}}
          </div>
        </ng-container>
      </div>
      <div class="audio-block-actions">
        <span *ngIf="isSaleCall && !isVoiceMail" (click)="toggleTranscript()" [attr.data-tooltip]="isTranscriptEnabled ? 'Hide Transcript':' Show Transcript'" data-tooltip-conf="bottom">
          <i class="fa-light" [class.fa-closed-captioning]="isTranscriptEnabled" [class.fa-closed-captioning-slash]="!isTranscriptEnabled"></i>
        </span>
        <span data-tooltip="Unpin" data-tooltip-conf="bottom">
          <i class="fa fa-thumbtack" (click)="toggleMiniFloater()"></i>
        </span>
        <span data-tooltip="Close" data-tooltip-conf="bottom">
          <i class="fa-light fa-xmark" (click)="onClose($event)"></i>
        </span>
      </div>
    </div>
  </div>
</div>
<div [hidden]="isMiniFloater" [ngClass]="{'override-transform': !isDraggable}" 
  [ngStyle]="{'position': 'fixed', 'right': right, 'top': top, 'z-index': 100, 'width': 'auto' }"
  [cdkDragFreeDragPosition]="dragPosition" cdkDrag  >
  <div class="audio-block-wrapper">
    <div class="flex-row flex-row--compact">
      <div class="flex-col-sm-12">
        <ng-container *ngIf="isDraggable; else nonDraggable">
          <div cdkDragHandle class="audio-block-header --move">
            <!-- hidden -->
            <i style="display: none;" *ngIf="!isDraggable" cdkDragHandle></i>
            <!-- --- -->
            <h4>{{customerName}}</h4>
            <!-- <h4>Maria Roselia</h4> -->
            <div *ngIf="!isVoiceMail" class="audio-swticher">
              <span (click)="isAudioLoaded && playSingleTrack(0)" [ngClass]="{ 'cursor-disabled': !isAudioLoaded }">
                Customer
                <i class="fa-light" [ngClass]="{
                      'fa-volume-slash': isAgentTrackMuted,
                      'fa-volume': !isAgentTrackMuted,
                      'cursor-disabled': !isAudioLoaded 
                    }" 
                  ></i>
              </span>
              <span (click)="isAudioLoaded && playSingleTrack(1)" [ngClass]="{ 'cursor-disabled': !isAudioLoaded }">
                Agent
                <i class="fa-light" [ngClass]="{
                      'fa-volume-slash': isCustomerTrackMuted,
                      'fa-volume': !isCustomerTrackMuted,
                      'cursor-disabled': !isAudioLoaded 
                    }"></i>
              </span>
            </div>
            <!--  Footer Actions-- -->
            <div class="audio-block-actions">
              <!-- <i class="fa-light fa-grip-dots-vertical --move" data-tooltip="Flecx Player" data-tooltip-conf="bottom" cdkDragHandle></i> -->
              <span *ngIf="isSaleCall && !isVoiceMail" (click)="toggleTranscript()" [attr.data-tooltip]="isTranscriptEnabled ? 'Hide Transcript':' Show Transcript'" data-tooltip-conf="top">
                <i class="fa-light" [class.fa-closed-captioning]="isTranscriptEnabled" [class.fa-closed-captioning-slash]="!isTranscriptEnabled"></i>
              </span>
               <span [attr.data-tooltip]="isFloaterCollapsed ? 'Collapse':'Expand'" data-tooltip-conf="top">
                <i class='fa-light'
                  [ngClass]="{'fa-arrow-up-right-and-arrow-down-left-from-center': !isFloaterCollapsed, 'fa-arrow-down-left-and-arrow-up-right-to-center': isFloaterCollapsed}"
                  (click)="toggleFloaterCollapse()"></i>
              </span>
              <span [attr.data-tooltip]="isMiniFloater ? 'Unpin':'Pin'"
                [attr.data-tooltip-conf]="isMiniFloater ? 'bottom':'top'">
                <i class="fa-light fa-thumbtack" (click)="toggleMiniFloater()"></i>
              </span>
              <ng-container *ngIf="!isDownloading ">
                <span [attr.data-interaction]="callSID + ' - Download Recording'" *ngIf="allowDownload && isAudioLoaded" data-tooltip="Download" data-tooltip-conf="top">
                  <i [attr.data-interaction]="callSID + ' - Download Recording'" [ngClass]="{ 'cursor-disabled': !isAudioLoaded }" class="fa-light fa-download" (click)="isAudioLoaded && downloadAudio()"></i>
                </span>
              </ng-container>
              <span *ngIf="isDownloading">
                <i class="fa-light fa-spinner"></i>
              </span>
              <span data-tooltip="Close" data-tooltip-conf="top">
                <i class="fa-light fa-xmark" (click)="onClose($event)"></i>
              </span>
            </div>
          </div>
        </ng-container>
        <ng-template #nonDraggable>
          <i style="display: none;" cdkDragHandle></i>
          <div class="audio-block-header">
            <h4>{{customerName}}</h4>
            <div *ngIf="!isVoiceMail" class="audio-swticher">
              <span (click)="isAudioLoaded && playSingleTrack(0)" [ngClass]="{ 'cursor-disabled': !isAudioLoaded }">
                Customer
                <i class="fa-light" [ngClass]="{
                      'fa-volume-slash': isAgentTrackMuted,
                      'fa-volume': !isAgentTrackMuted,
                      'cursor-disabled': !isAudioLoaded 
                    }" 
                  ></i>
              </span>
              <span (click)="isAudioLoaded && playSingleTrack(1)" [ngClass]="{ 'cursor-disabled': !isAudioLoaded }">
                Agent
                <i class="fa-light" [ngClass]="{
                      'fa-volume-slash': isCustomerTrackMuted,
                      'fa-volume': !isCustomerTrackMuted,
                      'cursor-disabled': !isAudioLoaded 
                    }"></i>
              </span>
            </div>
            <!--  Footer Actions-- -->
            <div class="audio-block-actions">
              <span *ngIf="isSaleCall && !isVoiceMail" (click)="toggleTranscript()" [attr.data-tooltip]="isTranscriptEnabled ? 'Hide Transcript':' Show Transcript'" data-tooltip-conf="top">
                <i class="fa-light" [class.fa-closed-captioning]="isTranscriptEnabled" [class.fa-closed-captioning-slash]="!isTranscriptEnabled"></i>
              </span>
              <span *ngIf="isDownloading">
                <i class="fa-light fa-spinner"></i>
              </span>
              <ng-container *ngIf="!isDownloading ">
                <span *ngIf="allowDownload && isAudioLoaded" [attr.data-interaction]="callSID + ' - Download Recording'" data-tooltip="Download" data-tooltip-conf="top">
                  <i [attr.data-interaction]="callSID + ' - Download Recording'" [ngClass]="{ 'cursor-disabled': !isAudioLoaded }" class="fa-light fa-download" (click)="isAudioLoaded && downloadAudio()"></i>
                </span>
              </ng-container>
            </div>
          </div>
        </ng-template>
      </div>
    </div>
    <div [hidden]="!isFloaterCollapsed" class="flex-row--compact flex-row--no-margin flex-row--compact flex-row--no-margin pos-r">
      <div *ngIf="!isAudioLoaded || !canPlay()" class="absolute-center flex-center-all">
          <i class="fa-light fa-solid fa-spin fa-spinner fa-fw" style="font-size: 2.2em;"></i>
          <!-- <span class="loading-text">FleCX Player</span> -->
      </div>
      <div class="flex-col-sm-12">
        <div id="visualizer-container">
          <ng-scrollbar #scrollbarRef track="all" style="height: 140px;">
            <canvas #visualizer width="555" height="130"></canvas>
          </ng-scrollbar>
        </div>
      </div>
    </div>
    <div class="flex-row flex-row--no-margin">
      <div class="flex-col-sm-12">
        <!-- <div [attr.data-tooltip]="hoverTime" class="audio-seekbar"
                (mousemove)="showHoverTime($event)" (mouseleave)="hideHoverTime()">
                <input type="range" #seekBar [(ngModel)]="seekBarValue" (input)="seekAudio($event)" class="audio-progress-bar"
                  min="0" max="100" value="0" id="audioSeekbar1" />
              </div> -->
        <div [ngClass]="{ 'cursor-disabled': !isAudioLoaded }" class="audio-seekbar" (mousemove)="showHoverTime($event)" (mouseleave)="hideHoverTime()">
          <input type="range" #seekBar [(ngModel)]="seekBarValue" (input)="seekAudio($event)" class="audio-progress-bar"
            min="0" max="100" value="0" id="audioSeekbar1" [disabled]="!isAudioLoaded" />
        </div>
        <ng-container *ngIf="isAudioLoaded">
          <div *ngIf="hoverTimeVisible" class="hover-time-tooltip" [style.top.px]="tooltipPositionY"
            [style.left.px]="tooltipPositionX">
            {{ hoverTime}}
          </div>
        </ng-container>
      </div>
      <div class="flex-col-sm-12">
        <div class="playback-timeline">
          <span>{{formatDate(getCurrentTime())}}</span>
          <span>{{formatDate(getTotalDuration())}}</span>
        </div>
      </div>
    </div>
    <div class="flex-row">
      <div class="flex-col-sm-12">
        <div class="playback-control-wrapper">
          <div [ngClass]="{ 'cursor-disabled': !isAudioLoaded }" class="volume-handle">
            <span 
            [attr.data-tooltip]="volume > 0 && !muted ? 'Mute' : 'Unmute'" 
            [attr.data-tooltip-conf]="'top'" 
            [ngClass]="{ 'cursor-disabled': !isAudioLoaded }">
            <i class="fa-light"
               [ngClass]="{
                 'fa-volume': volume > 0 && !muted,
                 'fa-volume-slash': volume === 0 || muted,
                 'cursor-disabled': !isAudioLoaded
               }"
               (click)="isAudioLoaded && toggleMute()">
            </i>
          </span>
            <div [ngClass]="{ 'cursor-disabled': !isAudioLoaded }" class="audio-seekbar --volume-seekbar">
              <input (input)="setVolume($event)" class="audio-progress-bar" [(ngModel)]="volume" type="range" min="0" max="100"
                step="1" [value]="volume" [disabled]="!isAudioLoaded" />
            </div>
            <span class="player-info-left">FleCX Player</span>
            <span style="bottom: 11px;left: 90px;font-size: 8px;position: absolute;" class="beta">Beta</span>

            <!-- use class player-info-left or player-info-center -->
          </div>

          <div class="playback-control" [ngClass]="{ 'cursor-disabled': !isAudioLoaded }">
            <!-- backward -->
            <span data-tooltip="Backward" data-tooltip-conf="top">
              <i [ngClass]="{ 'cursor-disabled': !isAudioLoaded }" class="fa-light fa-backward" (click)="isAudioLoaded && backward()"></i>
            </span>
          
            <!-- Play/Pause -->
            <span [attr.data-interaction]="callSID + ' - Play Recording'" *ngIf="isPaused()" data-tooltip="Play" data-tooltip-conf="top">
              <i [attr.data-interaction]="callSID + ' - Play Recording'"[ngClass]="{ 'cursor-disabled': !isAudioLoaded }" class="fa-solid fa-play big-play" (click)="isAudioLoaded && playAllTracks()"></i>
            </span>
            
            <span [attr.data-interaction]="callSID + ' - Pause Recording'" *ngIf="!isPaused()" data-tooltip="Pause" data-tooltip-conf="top">
              <i [attr.data-interaction]="callSID + ' - Pause Recording'" [ngClass]="{ 'cursor-disabled': !isAudioLoaded }" class="fa-solid fa-pause big-play" (click)="isAudioLoaded && pause()"></i>
            </span>
          
            <!-- forward -->
            <span data-tooltip="Forward" data-tooltip-conf="top">
              <i [ngClass]="{ 'cursor-disabled': !isAudioLoaded }" class="fa-light fa-forward" (click)="isAudioLoaded && forward()"></i>
            </span>
          </div>

          <div [ngClass]="{ 'cursor-disabled': !isAudioLoaded }" class="speed-handle">
            <div [ngClass]="{ 'cursor-disabled': !isAudioLoaded }" class="range-slider">
              <span>0.5x</span>
              <input (input)="setPlaybackRate($event)" class="audio-progress-bar" [(ngModel)]="activeSpeed" type="range"
              min="0.5" max="2.0" step="0.25" [value]="activeSpeed" [disabled]="!isAudioLoaded"/>
              <span>2x</span>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
@if(isSaleCall && !isVoiceMail ){
<app-audio-transcript [currentSegmentIndex]="currentSegmentIndex" [transcriptData]="transcriptData"
  [isPlayerDetached]="isDraggable" [isTranscriptEnabled]="isTranscriptEnabled" (closeTranscript)="onTranscriptClosed()">
</app-audio-transcript>
}
 }